import React from "react";
import { formatDuration } from "../../../lib/utils";

interface RecordingTimerProps {
  duration: number;
  className?: string;
}

export function RecordingTimer({ duration, className = "" }: RecordingTimerProps) {
  return (
    <div className={`text-lg font-medium font-poppins ${className}`}>
      <div
        style={{ width: "60px", textAlign: "center", display: "inline-block" }}
      >
        {formatDuration(duration)}
      </div>
    </div>
  );
}